import { Box, Container, Theme, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { InvitaeNavLeft } from "./InvitaeNavLeft";
import { InvitaeNavRight } from "./InvitaeNavRight";

const useStyles = makeStyles((theme: Theme) => ({
  navContainer: {
    [theme.breakpoints.down(420)]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

export const InvitaeNav = () => {
  const classes = useStyles();
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box bgcolor="common.white" width={1}>
      <Container className={classes.navContainer}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          component="nav"
          height={xs ? 80 : 96}
          aria-label="primary"
        >
          <InvitaeNavLeft />
          <InvitaeNavRight />
        </Box>
      </Container>
    </Box>
  );
};
